import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders current-club stay totals. Parents pass their own layout primitives
 * so sidebar and popup cards keep matching styles.
 * Optional `trailing` (e.g. Career History) sits beside the stay stats at 2/1
 * when `Cluster` is provided.
 */
export default function ClubStayStats({
  stay,
  Row,
  Item,
  Value,
  Label,
  Cluster,
  trailing,
}) {
  if (!stay) return null;
  const { appearances, goals, assists } = stay;
  if (appearances == null && goals == null && assists == null) return null;

  const stayItems = (
    <>
      {appearances != null ? (
        <Item>
          <>
            <Value>{appearances}</Value>
            <Label>Apps this stay</Label>
          </>
        </Item>
      ) : null}
      {goals != null ? (
        <Item>
          <>
            <Value>{goals}</Value>
            <Label>Goals this stay</Label>
          </>
        </Item>
      ) : null}
      {assists != null ? (
        <Item>
          <>
            <Value>{assists}</Value>
            <Label>Assists this stay</Label>
          </>
        </Item>
      ) : null}
    </>
  );

  if (trailing && Cluster) {
    return (
      <Row>
        <Cluster>{stayItems}</Cluster>
        <Item oneThird>{trailing}</Item>
      </Row>
    );
  }

  return <Row>{stayItems}</Row>;
}

ClubStayStats.propTypes = {
  stay: PropTypes.shape({
    appearances: PropTypes.number,
    goals: PropTypes.number,
    assists: PropTypes.number,
  }),
  Row: PropTypes.elementType.isRequired,
  Item: PropTypes.elementType.isRequired,
  Value: PropTypes.elementType.isRequired,
  Label: PropTypes.elementType.isRequired,
  Cluster: PropTypes.elementType,
  trailing: PropTypes.node,
};

ClubStayStats.defaultProps = {
  stay: null,
  Cluster: null,
  trailing: null,
};
